import {ThemeType} from '../../../theme/types';
import {
  mapBorderToBaseProperties,
  mapFontToBaseProperties,
} from '../../themed/functions';
import {BaseEditorProps, EditorProps} from '../types';
import {mapEditorColorsToBaseProperties} from './mapEditorColorsToBaseProperties';

export const mapEditorToBaseProperties = (
  theme: ThemeType,
  props: EditorProps,
): BaseEditorProps => {
  const {state = 'Default'} = props;

  return {
    ...mapFontToBaseProperties(theme, 'inline_14_default'),
    ...mapBorderToBaseProperties(theme, {
      borderStyle: 'none',
    }),
    ...mapEditorColorsToBaseProperties(theme, props),

    flex: 1,
    disabled: state === 'Disabled',
  };
};
